import { useEffect } from 'react'
import { MapInfo as MapInfoUI } from 'ui-components'
import { Tools } from '~map-preview/App/Layout/Nav/Tools'
import { useIsWorkspaceMember } from '~map-preview/hooks/useIsWorkspaceMember'
import { useReadmeNodes } from '~map-preview/states/map'
import { useMapNavStore } from '~map-preview/states/mapNav'

export const MapInfo = () => {
  const nodes = useReadmeNodes()
  const isWorkspaceMember = useIsWorkspaceMember()
  const { setOpenDrawer, setSideBar, setActiveMapSettingsTab } =
    useMapNavStore()

  if (!isWorkspaceMember && !nodes) return null

  return (
    <MapInfoUI
      onOpenAddInfo={() => {
        setActiveMapSettingsTab('info')
        setSideBar(Tools.settings.key)
        setOpenDrawer(true)
      }}
      content={nodes}
    />
  )
}
